module.exports = {"Laboratory":"Laboratory","":""}